import { render, staticRenderFns } from "./YearProductionResultTab.vue?vue&type=template&id=0a97e5e8&"
import script from "./YearProductionResultTab.vue?vue&type=script&lang=js&"
export * from "./YearProductionResultTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports